import { Location } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../../services/auth.service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'app-header-admin',
  templateUrl: './header-admin.component.html',
  styleUrl: './header-admin.component.scss',
  standalone: false,
})
export class HeaderAdminComponent {
  constructor(
    public userService: UserService,
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public location: Location
  ) {
    this.isMobile = window.innerWidth <= 768;
    this.initMenuItems();
  }

  isMobile = false;

  @HostListener('window:resize')
  onResize() {
    this.isMobile = window.innerWidth <= 768;
    this.initMenuItems();
  }

  public menuItems = [
    {
      label: 'Meine Termine',
      icon: 'fa-regular fa-calendar-heart',
      link: '/user',
      queryParams: { tab: 'appointments' },
    },
    {
      label: 'Seminar-Unterlagen',
      icon: 'fa-regular fa-book-copy',
      link: '/user/library',
    },
    {
      label: 'Bibliothek',
      icon: 'fa-regular fa-folders',
      link: '/member-areas',
    },

    {
      label: 'Mein Konto',
      icon: 'fa-regular fa-user',
      link: '/user',
      queryParams: { tab: 'account' },
    },
    {
      label: 'Nutzer Ansicht',
      icon: 'fa-regular fa-circle-user',
      link: '/home',
    },
    {
      label: 'Abmelden',
      icon: 'fa-regular fa-arrow-right-from-bracket',
      command: () => {
        this.logOut();
      },
    },
  ];

  private initMenuItems() {
    if (this.isMobile) {
      // add Seminare, News Banner, Buchungen, Rechnungen, Gutscheine, Fortbildungs Kategorien, Alle Kontakte at the start of the menu
      this.menuItems.unshift(
        {
          label: 'Seminare',
          icon: 'fa-regular fa-calendar',
          link: '/administration/seminars',
        },
        {
          label: 'Seminar Unterlagen',
          icon: 'fa-regular fa-paperclip-vertical',
          link: '/administration/seminar-attachments',
        },
        {
          label: 'News Banner',
          icon: 'fa-regular fa-newspaper',
          link: '/administration/news-banners',
        },
        {
          label: 'Buchungen',
          icon: 'fa-regular fa-shopping-cart',
          link: '/administration/bookings',
        },
        {
          label: 'Rechnungen',
          icon: 'fa-regular fa-file-invoice',
          link: '/administration/invoices',
        },
        {
          label: 'Gutscheine',
          icon: 'fa-regular fa-gift',
          link: '/administration/coupons',
        },
        {
          label: 'Fortbildungs Kategorien',
          icon: 'fa-regular fa-book-open',
          link: '/administration/training-categories',
        },
        {
          label: 'Alle Kontakte',
          icon: 'fa-regular fa-address-book',
          link: '/administration/contacts',
        }
      );
    }
  }

  public route(route: string) {
    this.router.navigate([route], { relativeTo: this.activatedRoute });
  }

  public logOut() {
    this.authService.logOut();
    this.router.navigate(['./login']);
  }
}
